import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Lock, ShieldCheck, Check } from 'lucide-react';
export function PricingCTA() {
  const includes = ['Ebook de 30 días con guía diaria', 'Parte práctica cada día', 'Técnicas de respiración y regulación', 'Método de equilibrio del organismo', 'Trabajo de creencias y patrones', 'Fe aplicada como herramienta', 'Audio de emergencia para momentos de caos'];
  return <section id="pricing" className="py-24 bg-warm-deep relative overflow-hidden" data-id="element-128">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-30" data-id="element-129">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gold/20 rounded-full blur-3xl" data-id="element-130" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cream/50 rounded-full blur-3xl" data-id="element-131" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-8 relative z-10" data-id="element-132">
        {/* SECCIÓN 8 | OFERTA + PRECIO */}
        <FadeIn data-id="element-133">
          <div className="bg-cream/90 backdrop-blur-sm p-8 md:p-12 rounded-3xl shadow-xl border border-white/50 mb-12" data-id="element-134">
            <h2 className="text-3xl md:text-4xl font-bold text-brown text-center mb-8" data-id="element-135">
              Todo lo que incluye "De Caos a Calma":
            </h2>

            <div className="space-y-4 mb-10 max-w-2xl mx-auto" data-id="element-136">
              {includes.map((item, index) => <div key={index} className="flex items-center justify-between border-b border-brown/10 pb-3" data-id="element-137">
                  <span className="text-lg text-brown-light" data-id="element-138">{item}</span>
                  <span className="text-gold" data-id="element-139">💛</span>
                </div>)}
            </div>

            <div className="text-center mb-10" data-id="element-140">
              <p className="text-lg text-brown-light mb-4" data-id="element-141">Todo esto por:</p>
              <div className="flex items-center justify-center gap-3 mb-4" data-id="element-142">
                <span className="text-2xl text-brown-light/50 line-through decoration-red-400 decoration-2" data-id="element-143">
                  €20.00
                </span>
                <span className="text-6xl font-bold text-brown" data-id="element-144">€6.99</span>
                <span className="text-xl text-brown-light ml-1" data-id="element-145">EUR</span>
              </div>
              <p className="text-sm text-sage font-medium" data-id="element-146">
                Acceso inmediato. Descarga instantánea. Sin suscripciones. Sin
                compromisos. Tuyo para siempre.
              </p>
            </div>

            <a href="https://caosacalma.com/cart/56509401694532:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart');
            }
          }} className="w-full max-w-xl mx-auto bg-gold hover:bg-gold-dark text-white text-lg md:text-xl font-bold py-5 px-8 rounded-full transition-all duration-300 shadow-lg shadow-gold/30 hover:shadow-xl hover:shadow-gold/40 hover:-translate-y-1 animate-pulse-slow flex items-center justify-center gap-2 no-underline" data-id="element-147">
              💛 QUIERO IR DE CAOS A CALMA →
            </a>

            <div className="flex items-center justify-center gap-2 mt-6 text-sm text-brown-light/80" data-id="element-148">
              <Lock size={14} data-id="element-149" />
              <span data-id="element-150">Pago 100% seguro.</span>
            </div>
          </div>
        </FadeIn>

        {/* SECCIÓN 9 | GARANTÍA */}
        <FadeIn delay={0.1} data-id="element-151">
          <div className="bg-sage/10 rounded-3xl p-8 md:p-10 border border-sage/20 mb-16 text-center" data-id="element-152">
            <div className="flex justify-center mb-4 text-sage" data-id="element-153">
              <ShieldCheck size={48} data-id="element-154" />
            </div>
            <h3 className="text-2xl font-bold text-brown mb-4" data-id="element-155">
              Mi Garantía Personal
            </h3>
            <p className="text-lg text-brown-light leading-relaxed max-w-2xl mx-auto" data-id="element-156">
              Si aplicas el proceso durante 30 días y sientes que no cambió nada
              — te devuelvo tu inversión completa.
              <br data-id="element-157" />
              <br data-id="element-158" />
              Sin preguntas difíciles. Sin trámites. Sin juicio.
              <br data-id="element-159" />
              <br data-id="element-160" />
              Porque creo en esto con todo mi corazón. Y no quiero que ninguna
              mamá sienta que arriesgó algo para encontrar su calma.
            </p>
          </div>
        </FadeIn>

        {/* SECCIÓN 10 | URGENCIA & CIERRE EMOCIONAL */}
        <FadeIn delay={0.2} data-id="element-161">
          <div className="text-center max-w-3xl mx-auto" data-id="element-162">
            <h3 className="text-3xl font-bold text-brown mb-6" data-id="element-163">
              Una última cosa antes de que te vayas...
            </h3>
            <div className="space-y-6 text-lg text-brown-light leading-relaxed mb-10" data-id="element-164">
              <p data-id="element-165">
                Sé que quizás estás pensando:
                <br data-id="element-166" />
                <span className="italic" data-id="element-167">
                  "Lo pienso y luego vuelvo." "A lo mejor después." "No sé si es
                  para mí."
                </span>
              </p>
              <p data-id="element-168">
                Y te entiendo. Yo también dudé muchas veces antes de dar el
                primer paso.
              </p>
              <p className="font-bold text-brown" data-id="element-169">Pero hay algo que aprendí:</p>
              <p data-id="element-170">
                El caos no para solo. La calma no llega sola. Y el mejor momento
                para empezar siempre fue ayer — el segundo mejor momento es
                ahora.
              </p>
              <p className="text-xl font-heading italic text-gold-dark" data-id="element-171">
                Tus hijos no necesitan que seas perfecta. Te necesitan en paz.
                <br data-id="element-172" />Y tú mereces sentirte bien. No algún día. Hoy.
              </p>
            </div>

            <a href="https://caosacalma.com/cart/56509401694532:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart');
            }
          }} className="inline-block bg-brown hover:bg-brown-light text-white text-lg font-bold py-4 px-10 rounded-full transition-all duration-300 shadow-lg hover:-translate-y-1 no-underline" data-id="element-173">
              💛 SÍ, QUIERO EMPEZAR HOY →
            </a>
            <p className="mt-4 text-brown-light font-medium" data-id="element-174">
              Para ti. Para ellos. De la mano de Dios.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}